<template>
  <div class="notice-wrapper">
    <PretendardText class="title">{{ title }}</PretendardText>
    <PretendardText class="date">{{ date }}</PretendardText>
  </div>
</template>

<script>
import PretendardText from "@/components/atoms/text/PretendardText.vue";

export default {
  name: "NoticeCard",
  components: { PretendardText },
  props: {
    title: String,
    date: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.notice-wrapper {
  display: flex;
  padding: 15px 0px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $line;

  & .title {
    color: #044a85;
    font-size: 16px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.6px;
  }

  & .date {
    color: $g04;
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.6px;
  }
}
</style>
